<template>
  <div
    class="raid_navigation inline-flex min-w-0 items-center gap-1.5"
    role="group"
    :aria-label="messages.planNavigation.navigationLabel"
  >
    <AppButton
      :disabled="previousRaid === null"
      :variant="ButtonVariant.Secondary"
      :size="ButtonSize.Sm"
      :aria-label="previousRaid === null ? messages.planNavigation.previousUnavailable : messages.planNavigation.previousAria(previousRaid.name)"
      @click="selectPrevious"
    >{{ messages.planNavigation.previous }}</AppButton>

    <span class="min-w-0 max-w-48 truncate text-sm font-semibold text-text-primary" :title="activeRaid.name">
      <span class="mr-1 font-mono text-2xs uppercase tracking-widest text-text-muted">{{ messages.planNavigation.currentGvg }}</span>{{ activeRaid.name }}
    </span>

    <AppButton
      :disabled="nextRaid === null"
      :variant="ButtonVariant.Secondary"
      :size="ButtonSize.Sm"
      :aria-label="nextRaid === null ? messages.planNavigation.nextUnavailable : messages.planNavigation.nextAria(nextRaid.name)"
      @click="selectNext"
    >{{ messages.planNavigation.next }}</AppButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { defineLocaleCatalog } from '@/shared/i18n'
import { useLocaleMessages } from '@/shared/composables/useI18n'
import { AppButton, ButtonSize, ButtonVariant } from '@/shared/ui'
import { plannedRaidNeighbors } from '../../lib/raidPlanNavigation'
import type { RaidId, RaidSummary } from '../../types'
import { calendarEn } from './locales/en.ts'
import { calendarRu } from './locales/ru.ts'

export interface RaidPlanNavigationProps {
  readonly raids: ReadonlyArray<RaidSummary>
  readonly activeRaid: RaidSummary
}

const props = defineProps<RaidPlanNavigationProps>()
const emit = defineEmits<{
  (event: 'select', raidId: RaidId): void
}>()
const messages = useLocaleMessages(defineLocaleCatalog({ en: calendarEn, ru: calendarRu }))

const neighbors = computed(() => plannedRaidNeighbors(props.raids, props.activeRaid.id))
const previousRaid = computed(() => neighbors.value.previous)
const nextRaid = computed(() => neighbors.value.next)

function selectPrevious(): void {
  if (previousRaid.value !== null) emit('select', previousRaid.value.id)
}

function selectNext(): void {
  if (nextRaid.value !== null) emit('select', nextRaid.value.id)
}
</script>
